import { uniqBy } from "lodash";

const initialState = {
  customerList: [],
  totalPages: 0,
  loadingCustomerList: false,
  customerListError: null,
  selectedCustomer: {},
  listCustomers: [],
  totalPagesListCustomers: 0,
  previewCustomers: [],
  totalPagesPreviewCustomers: 0,
  loadingApplyFilters: false,
  loadingSelectedCustomers: false,
  loadingGetListCustomers: false,
  loadingGetPreviewCustomers: false,
  selectedCustomersRequestId: null,
  contactGroups: [],
  loadedPages: []
};

const customerListReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'START_CUSTOMER_LIST_REQUEST':
      return {
        ...state,
        loadingCustomerList: true,
        customerListError: null
      };
    case 'GET_CUSTOMER_LIST':
      return {
        ...state,
        customerList: action.data.groups,
        totalPages: action.data.total_pages
      };
    case 'END_CUSTOMER_LIST_REQUEST':
      return {
        ...state,
        loadingCustomerList: false
      };
    case 'LOAD_DATA_FAILURE':
      return {
        ...state,
        customerListError: action.err || action.error,
        loadingCustomerList: false
      };
    case 'DELETE_CUSTOMER_LIST':
      return {
        ...state,
        customerList: state.customerList.filter((item) => item.id !== action.data.group.id)
      };
    case 'SET_SELECTED_CUSTOMER_FOR_LIST':
      if (
        action.requestId
        && action.requestId !== state.selectedCustomersRequestId
      ) {
        return state;
      }

      return {
        ...state,
        selectedCustomer: action.data,
        loadingSelectedCustomers: action.requestId ? state.loadingSelectedCustomers : false,
        selectedCustomersRequestId: action.requestId || null
      };
    case 'SET_LIST_CUSTOMERS':
      return {
        ...state,
        listCustomers: action.data.customers,
        totalPagesListCustomers: action.data.total_pages
      };
    case 'SET_PREVIEW_CUSTOMERS':
      return {
        ...state,
        previewCustomers: action.data.customers,
        totalPagesPreviewCustomers: action.data.total_pages
      };
    case 'START_SAVING_CUSTOMER_LIST_REQUEST':
      return {
        ...state,
        savingCustomerList: true
      };
    case 'END_SAVING_CUSTOMER_LIST_REQUEST':
      return {
        ...state,
        savingCustomerList: false
      };
    case 'START_SELECTED_CUSTOMERS_REQUEST':
      return {
        ...state,
        loadingSelectedCustomers: true,
        selectedCustomersRequestId: action.requestId
      };
    case 'END_SELECTED_CUSTOMERS_REQUEST':
      if (
        action.requestId
        && action.requestId !== state.selectedCustomersRequestId
      ) {
        return state;
      }

      return {
        ...state,
        loadingSelectedCustomers: false
      };
    case 'START_GET_LIST_CUSTOMERS_REQUEST':
      return {
        ...state,
        loadingGetListCustomers: true
      };
    case 'END_GET_LIST_CUSTOMERS_REQUEST':
      return {
        ...state,
        loadingGetListCustomers: false
      };
    case 'START_GET_PREVIEW_CUSTOMERS_REQUEST':
      return {
        ...state,
        loadingGetPreviewCustomers: true
      };
    case 'END_GET_PREVIEW_CUSTOMERS_REQUEST':
      return {
        ...state,
        loadingGetPreviewCustomers: false
      };
    case 'SET_CONTACT_GROUPS_SEARCH_RESULTS':
      return {
        ...state,
        contactGroups: uniqBy([...state.contactGroups, ...action.data.groups], 'value'),
        loadedPages: state.loadedPages.includes(action.data.page)
          ? state.loadedPages
          : [...state.loadedPages, action.data.page],
      };
    default:
      return state;
  }
};

export default customerListReducer;
